package org.ttt.autogenesis.fleetcontrol.client

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.Promise

internal actual suspend fun compressAccessToken(accessToken: String): String?
{
    val compressionStreamConstructor: dynamic = js("globalThis.CompressionStream")
    if(compressionStreamConstructor == null)
    {
        return null
    }

    val textEncoder: dynamic = js("new globalThis.TextEncoder()")
    val bytes: dynamic = textEncoder.encode(accessToken)
    val compressionStream: dynamic = js("new globalThis.CompressionStream('gzip')")
    // Keep the input Response construction separate. Kotlin/JS can otherwise
    // parse a nested `new Response(...).body.pipeThrough(...)` expression as
    // a constructor call on `pipeThrough`, causing Chrome to invoke the inner
    // DOM Response constructor without `new`.
    val inputResponse: dynamic = js("new globalThis.Response(bytes)")
    val compressedResponse: dynamic = js(
        "new globalThis.Response(inputResponse.body.pipeThrough(compressionStream))"
    )
    val compressedBuffer = (compressedResponse.arrayBuffer() as Promise<dynamic>).await()
    val compressedBytes: dynamic = js("new globalThis.Uint8Array(compressedBuffer)")
    val binary = js(
        "(function(){var value='';for(var i=0;i<compressedBytes.length;i++){value+=String.fromCharCode(compressedBytes[i]);}return value;})()"
    ) as String
    return window.btoa(binary)
        .replace('+', '-')
        .replace('/', '_')
        .trimEnd('=')
}

